import { render, staticRenderFns } from "./NewRefillCreator.vue?vue&type=template&id=37aa53b5&"
import script from "./NewRefillCreator.vue?vue&type=script&lang=js&"
export * from "./NewRefillCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports